import SiteChrome from "@chrome/SiteChrome";
import { CanonicalLink } from "@components/head/CanonicalLink";
import { HtmlPageTitle } from "@components/head/HtmlPageTitle";
import { MetaDescription } from "@components/head/MetaDescription";
import HomePage from "@components/homepage/HomePage";

const MainPage = () => (
  <SiteChrome noPadding>
    <HtmlPageTitle title="Blues Developers: Cellular, Wi-Fi, LoRa & Satellite IoT" />
    <MetaDescription description="Tutorials, SDKs, and docs for Blues Notecard - your IoT connectivity choice for LTE Cat-1, Cat-1 bis, LTE-M, NB-IoT, Wi-Fi, LoRa, and Satellite." />
    <CanonicalLink path="" />
    <HomePage />
  </SiteChrome>
);

export default MainPage;
